<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Active Visitors
            <v-spacer></v-spacer>
            <v-text-field
              v-model="activeSearch"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="activeVisitors"
            :search="activeSearch"
          ></v-data-table>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card v-if="admin.boardMember">
          <v-card-title>
            Visitors Log
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            v-if="admin.boardMember"
            :headers="permitHeaders"
            :items="permits"
            :search="search"
            items-per-page="15"
            sort-by="formattedDate"
            sort-desc="true"
          ></v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { membersRef, householdsRef, visitorsRef } from "../../firebaseApp";
export default {
  data: () => ({
    guests: [],
    permits: [],
    activeVisitors: [],
    admin: {},
    search: "",
    activeSearch: "",
    headers: [
      {
        text: "Unit",
        align: "left",
        sortable: false,
        value: "unit",
      },
      { text: "Tag", value: "licensePlate" },
      { text: "Year", value: "carYear" },
      { text: "Model", value: "carModel" },
      { text: "Car Color", value: "color" },
      { text: "Expiration Date", value: "formattedExpDate" },
    ],
    permitHeaders: [
      {
        text: "Unit",
        align: "left",
        sortable: false,
        value: "unit",
      },
      { text: "Name", value: "name" },
      { text: "Tag", value: "licensePlate" },
      { text: "Year", value: "carYear" },
      { text: "Model", value: "carModel" },
      { text: "Car Color", value: "color" },
      { text: "Date Added", value: "formattedDate" },
      { text: "Expiration Date", value: "formattedExpDate" },
    ],
  }),
  watch: {
    "$store.state.admin": function () {
      this.admin = this.$store.state.admin;
      this.loadVisitors();
    },
  },
  methods: {
    getHouseHolds() {
      let activeVisitors = this.activeVisitors;
      householdsRef.on("value", (snap) => {
        snap.forEach((household) => {
          activeVisitors.forEach((visitor) => {
            if (visitor.householdKey == household.key) {
              visitor.unit = household.val().aptNumber;
            }
          });
        });
      });
    },
    loadVisitors() {
      let guests = [];
      membersRef.on("value", (snap) => {
        snap.forEach((member) => {
          if (
            member.val().guest &&
            member.val().communityCode == this.admin.communityCode
          ) {
            var mem = member.val();
            guests.push(mem);
          }
        });
        this.guests = guests;
        this.loadActiveVisitors();
      });
      let permits = [];
      visitorsRef.on("value", (snap) => {
        snap.forEach((permit) => {
          if (permit.val().communityCode == this.admin.communityCode) {
            let mem = {};
            mem = permit.val();
            mem.id = permit.key;
            mem.formattedDate = this.formatDate(permit.val().dateAdded);
            mem.formattedExpDate = this.formatDate(permit.val().expirationDate);
            permits.push(mem);
          }
        });
        if (permits.length) {
          this.permits = permits;
        }
      });
    },
    formatDate(timestamp) {
      var formattedDate = new Date(timestamp);
      formattedDate =
        formattedDate.toLocaleDateString("en-US") +
        " " +
        formattedDate.toLocaleTimeString("en-US");
      return formattedDate;
    },
    loadActiveVisitors() {
      var today = Date.now();
      var activeVisitors = [];
      this.guests.forEach((guest) => {
        var expirationDate = guest.expirationDate;
        if (expirationDate > today) {
          guest.formattedExpDate = this.formatDate(expirationDate);
          activeVisitors.push(guest);
        }
      });
      this.activeVisitors = activeVisitors;
      this.getHouseHolds();
    },
    isOver24Hours(date) {
      let oneDay = new Date(new Date().getTime() + 1 * 24 * 60 * 60 * 1000),
        formattedDate = new Date(date);
      if (oneDay > formattedDate) {
        return false;
      } else if (oneDay < formattedDate) {
        return true;
      }
    },
  },
  mounted() {
    this.admin = this.$store.state.admin;
    this.loadVisitors();
  },
  created() {},
};
</script>